import { Drawer } from '../../../components/elements/Drawer'
import useLayoutHook from '../../../hooks/layoutHook';

type VerificationDetailsDrawerProps = {
    isOpen: boolean;
    vehicleInfo: () => JSX.Element
    onClose: () => void
}

const VerificationDetailsDrawer = ({ isOpen, vehicleInfo, onClose }: VerificationDetailsDrawerProps) => {
    const { isMobile } = useLayoutHook();

    return (
        <div className="relative mt-6">
            {/* Drawer */}
            <Drawer isOpen={isOpen} onClose={onClose} position="right" size={isMobile ? 'full' : 'xxl'} height='full'>
                <div className="">
                    {vehicleInfo()}
                </div>
            </Drawer>
        </div>
    )
}

export default VerificationDetailsDrawer